export default __webpack_public_path__ + "static/media/imgSpinner1.d44b4dd3.svg";